export enum Variant
{
    Primary = "Primary",    
    Secondary = "Secondary",
    Success = "Success",
    Warning = "Warning",
    Danger = "Danger",
    PrimaryBordered = "PrimaryBordered",
    SecondaryBordered = "SecondaryBordered",
    SuccessBordered = "SuccessBordered",
    WarningBordered = "WarningBordered",
    DangerBordered = "DangerBordered",
    Light = "Light",
    Dark = "Dark"
};

export enum StatusVariant {
    Overdue = 'Overdue',
    DueBy = 'DueBy',
    Done = 'Done',
    Skipped = 'Skipped',
    InProgress = 'InProgress'
};

export const VariantValuesMap = {
    [Variant.Primary]: "primary",    
    [Variant.Secondary]: "secondary",
    [Variant.Success]: "success",
    [Variant.Warning]: "warning",
    [Variant.Danger]: "danger",
    [Variant.PrimaryBordered]: "primary-bordered",
    [Variant.SecondaryBordered]: "secondary-bordered",
    [Variant.SuccessBordered]: "success-bordered",
    [Variant.WarningBordered]: "warning-bordered",
    [Variant.DangerBordered]: "danger-bordered",
    [Variant.Light]: "light",
    [Variant.Dark]: "dark"
};
const variantsFilledColoured = [ Variant.Primary, Variant.Secondary, Variant.Success, Variant.Warning, Variant.Danger, Variant.Dark ] as Variant[];
const variantsBordered = [ Variant.Primary, Variant.Secondary, Variant.Success, Variant.Warning, Variant.Danger, Variant.Dark ] as Variant[];
const variantsFilled = variantsFilledColoured.join(Variant.Light);
const variantsAll = [ variantsFilled, variantsBordered ];

export const Variants = {
    VariantsFilledColoured: variantsFilledColoured,
    VariantsBordered: variantsBordered,
    VariantsFilled: variantsFilled,
    VariantsAll: variantsAll,
}

export enum Sizes
{
    XSmall = "XSmall",    
    Smaller = "Smaller",
    Small = "Small",
    Medium = "Medium",
    Large = "Large",
    Larger = "Larger",   
    XLarge = "XLarge",    
    XXLarge = "XXLarge"
}

export const SizesValuesMap = {
    [Sizes.XSmall]: 'x-small',
    [Sizes.Smaller]: 'smaller',
    [Sizes.Small]: 'small',
    [Sizes.Medium]: 'medium',
    [Sizes.Large]: 'large',
    [Sizes.Larger]: 'larger',
    [Sizes.XLarge]: 'x-large',
    [Sizes.XXLarge]: 'xx-large'
};

export enum Breakpoint {
    XSmall = "XSmall",
    Small = "Small",
    Medium = "Medium",
    Large = "Large",
    Larger = "Larger",
    XLarge = "XLarge"
}

export const BreakpointValuesMap = {
    [Breakpoint.XSmall]: 'xs',
    [Breakpoint.Small]: 'sm',
    [Breakpoint.Medium]: 'md',
    [Breakpoint.Large]: 'lg',
    [Breakpoint.Larger]: 'xl',
    [Breakpoint.XLarge]: 'xxl'
};

export enum Placement
{
    PositionRelative = "PositionRelative",
    PositionAbsoluteTopRight = "PositionAbsoluteTopRight",
    PositionAbsoluteTopLeft = "PositionAbsoluteTopLeft",    
    PositionAbsoluteBottomRight = "PositionAbsoluteBottomRight",
    PositionAbsoluteBottomLeft = "PositionAbsoluteBottomLeft"
}

export const PlacementValuesMap = {
    [Placement.PositionRelative]: 'position-relative',
    [Placement.PositionAbsoluteTopRight]: 'position-absolute-top-right',
    [Placement.PositionAbsoluteTopLeft]: 'position-absolute-top-left',
    [Placement.PositionAbsoluteBottomRight]: 'position-absolute-bottom-right',
    [Placement.PositionAbsoluteBottomLeft]: 'position-absolute-bottom-left'
};

export enum States {
    Normal = "Normal",
    Active = "Active",
    Inactive = "Inactive"
}

export const StatesValuesMap = {
    [States.Normal]: 'normal',
    [States.Active]: 'active',
    [States.Inactive]: 'inactive'
};

export enum FlexDirection {    
    Row = "Row",    
    RowReverse = "RowReverse",    
    Column = "Column",    
    ColumnReverse = "ColumnReverse"
};

export const FlexDirectionValuesMap = {
    [FlexDirection.Row]: 'flex-row',
    [FlexDirection.RowReverse]: 'flex-row-reverse',
    [FlexDirection.Column]: 'flex-column',
    [FlexDirection.ColumnReverse]: 'flex-column-reverse'
};

export enum AlignItems{
    Start = "align-items-start",
    Center = "align-items-center",
    End = "align-items-end",
    Between = "align-items-between",
    Stretch = "align-items-stretch"
}

export const AlignItemsValuesMap = {
    [AlignItems.Start]: "align-items-start",
    [AlignItems.Center]: "align-items-center",
    [AlignItems.End]: "align-items-end",
    [AlignItems.Between]: "align-items-between",
    [AlignItems.Stretch]: "align-items-stretch"
};

export enum AlignSelf{
    Start = "align-self-start",
    Center = "align-self-center",
    End = "align-self-end",
    Between = "align-self-between",
    Stretch = "align-self-stretch"
}

export const AlignSelfValuesMap = {
    [AlignSelf.Start]: "align-self-start",
    [AlignSelf.Center]: "align-self-center",
    [AlignSelf.End]: "align-self-end",
    [AlignSelf.Between]: "align-self-between",
    [AlignSelf.Stretch]: "align-self-stretch"
};

export function enumAttributeConverter<TEnum extends object>(theEnum: TEnum, defaultValue: string | undefined = undefined) {
    return {
        fromAttribute: (value: string) => {            
            for(const key of Object.values(theEnum)) {
                if (value && value.toLowerCase() === key.toLowerCase()) {
                    return key;
                }
            }
            return defaultValue;
        },
        toAttribute: (value: keyof TEnum) => {
            return value;
        }
    };
}